import { FunctionComponent as F } from "react";
import Stack from '@mui/material/Stack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TextTooltip from "../Tooltip/TextTooltip";
import { SortDirection } from "../../../core/types/component";


interface IProps
{
  headingText: string,
  sort: SortDirection | null,
  handleToggleSort: () => void,
  tooltip?: string,
}

const HeadingSort: F<IProps> = (props: IProps) =>
{
  return (
    <Stack
      direction='row'
      spacing={1}
      style={{ cursor: 'default' }}
      onClick={props.handleToggleSort}>
      {props.tooltip ?
        <TextTooltip lines={[props.tooltip]} tooltipPlacement='top'>
          <b>{props.headingText}</b>
        </TextTooltip> :
        <b>{props.headingText}</b>}
      {(() =>
      {
        switch(props.sort)
        {
        case SortDirection.alphabetical:
          return <KeyboardArrowDownIcon/>;
        case SortDirection.reverseAlphabetical:
          return <KeyboardArrowUpIcon/>;
        case null:
          return <KeyboardArrowDownIcon style={{ color: 'transparent' }}/>;
        default:
          return <></>;
        }
      })()}
    </Stack>);
};

export default HeadingSort;
